import ProfileView from '@/app/components/talent_card/views/ProfileView.vue';
import CallLogsView from '@/app/components/talent_card/views/CallLogs.vue';
import CallLogsIndexView from '@/app/components/talent_card/views/CallLogsIndex.vue';
import CallLogsCreateView from '@/app/components/talent_card/views/CallLogsCreate.vue';
import FormListView from '@/app/components/talent_card/views/FormListView.vue';
import FormView from '@/app/components/talent_card/views/FormView.vue';
import CommentsView from '@/app/components/talent_card/views/CommentsView.vue';
import TalentEmailView from '@/app/components/talent_card/views/TalentEmailView.vue';
import TalentFilesView from '@/app/components/talent_card/views/TalentFilesView.vue';
import TalentFileView from '@/app/components/talent_card/views/TalentFileView.vue';
export var talentCardRoutes = [
    {
        path: 'profile',
        name: 'TalentCard.Profile',
        component: ProfileView,
    },
    {
        path: 'forms',
        name: 'TalentCard.Forms',
        component: FormListView,
        children: [
            {
                path: ':form',
                name: 'TalentCard.ShowForm',
                component: FormView,
            },
        ],
    },
    {
        path: 'call-logs',
        component: CallLogsView,
        children: [
            {
                path: 'new',
                name: 'TalentCard.CallLogs.Create',
                component: CallLogsCreateView,
            },
            {
                path: '/',
                name: 'TalentCard.CallLogs.Index',
                component: CallLogsIndexView,
            },
        ],
    },
    {
        path: 'email',
        name: 'TalentCard.Email',
        component: TalentEmailView,
        children: [
            {
                path: 'new',
                name: 'TalentCard.Email.New',
                component: TalentEmailView,
            },
        ],
    },
    {
        path: 'comments',
        name: 'TalentCard.Comments',
        component: CommentsView,
    },
    {
        path: 'files',
        name: 'TalentCard.Files',
        component: TalentFilesView,
        children: [
            {
                path: ':file',
                name: 'TalentCard.ViewFile',
                component: TalentFileView,
            },
        ],
    },
];
